import { getCellNameByIndex } from "./main";
import { IGrid } from "@dhx/ts-grid";

export class XlsxDriver {
	toJsonArray(data: any, grid: IGrid) {
		const sheets = [];
		const formats = [];
		const styles = {};

		data.styles.forEach((style: any, i: number) => {
			const allowedProps = [
				"background",
				"color",
				"textAlign",
				"verticalAlign",
				"textDecoration",
				"fontWeight",
				"fontStyle",
			];

			const css = allowedProps.reduce((acc, prop) => {
				if (style[prop]) {
					acc[prop] = style[prop];
				}
				return acc;
			}, {});

			formats.push(style.format);
			styles["imported_class" + i] = css;
		});

		data.data.forEach(item => {
			const cells = [];
			item.cells.forEach((row, rowInd) => {
				row.forEach((col, colInd) => {
					if (col) {
						const cell = {
							cell: getCellNameByIndex(rowInd, colInd + 1, grid),
							value: col.v,
							css: ["imported_class" + col.s],
							format: formats[col.s],
						};
						cells.push(cell);
					}
				});
			});
			sheets.push({ name: item.name, data: cells, cols: item.cols, rows: item.rows, merged: item.merged });
		});

		return {
			sheets,
			styles,
		};
	}
}
